import { FsTimeAttackRoundSpan } from "./FsTimeAttackRoundSpan";

export type FsCutoffSpan = {
  cutoffTimeMs: number | undefined;
};

export const isFsCutoffSpan = (
  span: FsTimeAttackRoundSpan
): span is FsCutoffSpan => {
  return (span as FsCutoffSpan).cutoffTimeMs !== undefined;
};

export const mapCutoffSpan = (fsModel: FsCutoffSpan) => {
  if (!fsModel.cutoffTimeMs) {
    return undefined;
  }

  return {
    cutoffTimeMs: fsModel.cutoffTimeMs,
  };
};
